import axios from 'axios';

const cdnApi = axios.create({
		baseURL: process.env.CDN_HOST,
	}),
	getNotificationList = () =>
		cdnApi.get(`web/${environment.region}/notifications.json`).then((res) => res.data),
	notificationAPI = {
		install(Vue) {
			Vue.prototype.$notificationAPI = {
				getNotificationList,
			};
		},
	};
export default notificationAPI;



// WEBPACK FOOTER //
// ./src/plugins/NotificationAPI.js